if (!customElements.get('lp-market-topbar')) {
  customElements.define(
    'lp-market-topbar',
    class LPMarketTopbar extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-lp-market-dialog]')
        this.openers = [...this.querySelectorAll('[data-lp-market-open]')]
        this.rotationMs = Math.max(3, Number(this.dataset.rotationSeconds) || 6) * 1000
        this.lastTrigger = null
        this.openers.forEach((button) => button.addEventListener('click', () => this.open(button)))
        this.querySelectorAll('[data-lp-market-close]').forEach((button) =>
          button.addEventListener('click', () => this.close()),
        )
        this.onKeydown = (event) => {
          if (event.key === 'Escape') this.close()
        }
        document.addEventListener('keydown', this.onKeydown)
        this.startRotator()
      }
      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown)
        window.clearInterval(this.timer)
      }
      open(trigger, returnTarget = trigger) {
        this.lastTrigger = returnTarget instanceof HTMLElement ? returnTarget : trigger
        this.dialog.hidden = false
        this.dialog.setAttribute('aria-hidden', 'false')
        document.body.classList.add('lp-market-topbar-open')
        this.dialog.querySelector('[data-lp-market-close]')?.focus()
      }
      close() {
        if (!this.dialog || this.dialog.hidden) return
        this.dialog.hidden = true
        this.dialog.setAttribute('aria-hidden', 'true')
        document.body.classList.remove('lp-market-topbar-open')
        this.lastTrigger?.focus()
      }
      startRotator() {
        const messages = [...this.querySelectorAll('[data-lp-market-message]')]
        if (messages.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return
        let index = 0
        this.timer = window.setInterval(() => {
          messages[index].hidden = true
          messages[index].setAttribute('aria-hidden', 'true')
          index = (index + 1) % messages.length
          messages[index].hidden = false
          messages[index].setAttribute('aria-hidden', 'false')
        }, this.rotationMs)
      }
    },
  )
}
